import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import shopCore, { getShopList, setShopId } from "../core/shop.core";

export default function useShopList() {
  const query = useQuery({
    queryKey: ["shopList"],
    queryFn: getShopList,
  });

  useEffect(() => {
    const shopList = query.data;
    if (shopList) {
      const shopId = shopCore.getShopId();
      if (!shopId) {
        setShopId(shopList[0].id);
        window.location.reload();
      }
    }
  }, [query.data]);

  return query;
}
